import { Check as CheckIcon } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";

export function CrmCompanyConnectedLabel() {
  const { t } = useTranslate("CrmOrganisations");

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <CheckIcon fontSize="small" color="primary" />
      <Typography variant="body2" color="primary">
        {t("Connected")}
      </Typography>
    </Stack>
  );
}
